import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api`;

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    Authorization: `Bearer ${token}`,
  };
};

/// GET
// Fonction pour récupérer la liste des modules administrables
export const getAllAdminPermissionModules = async () => {
  try {
    const response = await axios.get(`${apiUrl}/admin-permissions/modules`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors du chargement des modules de permissions admin :",
      error
    );
    return [];
  }
};

// Fonction pour récupérer les permissions admin d'un utilisateur
export const getUserAdminPermissions = async (userId) => {
  try {
    const response = await axios.get(
      `${apiUrl}/users/${userId}/admin-permissions`,
      {
        headers: getAuthHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors du chargement des permissions admin de l'utilisateur :",
      error
    );
    return [];
  }
};

/// PUT
// Fonction pour remplacer toutes les permissions admin d'un utilisateur
export const replaceUserAdminPermissions = async (userId, permissions = []) => {
  try {
    const response = await axios.put(
      `${apiUrl}/users/${userId}/admin-permissions`,
      { permissions },
      {
        headers: getAuthHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors de la mise à jour des permissions admin de l'utilisateur :",
      error
    );
    throw error;
  }
};

/// DELETE
// Fonction pour supprimer une permission admin précise d'un utilisateur
export const deleteUserAdminPermission = async (userId, permissionId) => {
  try {
    const response = await axios.delete(
      `${apiUrl}/users/${userId}/admin-permissions/${permissionId}`,
      {
        headers: getAuthHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors de la suppression de la permission admin :",
      error
    );
    throw error;
  }
};